/**
 * Zwaraca informację, czy przekazana wartość jest typu nullowego (null, undefined, NaN, "", itp.)
 *
 * @export
 * @param {*} item
 * @returns {boolean}
 */
export function isNullable(item: any): boolean {
  return !item && item !== false && item !== 0;
}
